import { formatHubSupportTicketStatusLabel } from "@/lib/hubSupportTicketStatus";
import {
  HUB_NOTIFICATION_TOPIC_LABELS,
  isHubNotificationTopic,
  type NotificationListRow,
} from "@/lib/notificationsApi";

export function notificationTopicDisplayLabel(row: NotificationListRow): string {
  if (row.topic === "purchase_request" && row.sourceStatus === "inventory_review") {
    return "Inventory review";
  }
  if (isHubNotificationTopic(row.topic)) {
    return HUB_NOTIFICATION_TOPIC_LABELS[row.topic];
  }
  return row.topic;
}

export function notificationSourceStatusLabel(row: NotificationListRow): string | null {
  if (row.topic !== "support_ticket") {
    return null;
  }
  const status = row.sourceStatus?.trim() ?? "";
  if (status === "") {
    return null;
  }
  return formatHubSupportTicketStatusLabel(status);
}
